module.exports = __webpack_public_path__ + "static/media/NonTech.f6c09a78.svg";